// components/ui/Input.js
import "./Input.css";

export function Input({
  className = "",
  type = "text",
  placeholder = "",
  value,
  onChange,
  ...props
}) {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      {...props}
      className={`custom-input nm-cursor ${className} h-12`}
    />
  );
}
